import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { LoadService } from '../_services';
import * as LoadActions from '../_actions/load';

@Injectable({
  providedIn: 'root',
})
export class LoadEffects {
  loadLoads$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadActions.loadLoads),
      mergeMap(() =>
        this.loadService.getLoads().pipe(
          map((loads) => LoadActions.loadLoadsSuccess({ loads })),
          catchError((error) => of(LoadActions.loadLoadsFailure({ error })))
        )
      )
    )
  );

  addLoad$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadActions.addLoad),
      mergeMap(({ load }) =>
        this.loadService.saveLoad(load).pipe(
          map((savedLoad) => LoadActions.addLoadSuccess({ load: savedLoad })),
          catchError((error) => of(LoadActions.addLoadFailure({ error })))
        )
      )
    )
  );

  updateLoad$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadActions.updateLoad),
      mergeMap(({ load }) =>
        this.loadService.saveLoad(load).pipe(
          map((updatedLoad) => LoadActions.updateLoadSuccess({ load: updatedLoad })),
          catchError((error) => of(LoadActions.updateLoadFailure({ error })))
        )
      )
    )
  );

  deleteLoad$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadActions.deleteLoad),
      mergeMap(({ id }) =>
        this.loadService.deleteLoad(id).pipe(
          map(() => LoadActions.deleteLoadSuccess({ id })),
          catchError((error) => of(LoadActions.deleteLoadFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private loadService: LoadService
  ) {}
}
